<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="课程：">
        <el-select v-model="query.customerLevelId" placeholder="请选择" clearable size="small" multiple collapse-tags>
          <el-option :label="item.value" :value="item.key" v-for="item in courseList" :key="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学习时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import courseSubjectApi from '@/api/course/courseSubject'
// import customerLevelApi from '@/api/course/customerLevel'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
      },
      courseList:[]
    }
  },
  created() {
    this.getOption()
  },
  methods: {
    // 获取课程
    getOption() {
      courseSubjectApi.fetchForOptions().then(({
        data
      }) => {
        this.courseList=data
      })
    },
    handleDownload() {
      let query={...this.query}
      query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : ""
      query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : ""
      return this.$common.confirm('是否确认导出')
        .then(() => courseSubjectApi.exportExcels(query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },
  }
}
</script>

<style>
</style>
